import {
	Button,
} from "@mui/material";

import React, { useEffect, useState } from 'react';

export default function SessionFeedbackViewer({ gotoanalytics }) {
  const [feedback, setFeedback] = useState('Loading...');

  useEffect(() => {
    fetch('/data/session_feedback_script.txt')
      .then((res) => res.text())
      .then((text) => setFeedback(text))
      .catch(() => setFeedback('Failed to load feedback script.'));
  }, []);

  return (
    <div className="p-6 max-w-4xl mx-auto">
  <Button color="inherit" onClick={gotoanalytics} sx={{ mr: 1 }}>
	Analytics
  </Button>
  <br/>
      <h1 className="text-3xl font-bold mb-4">Session Feedback Script</h1>
      <div className="bg-white shadow-md rounded-lg overflow-hidden">
        <div className="h-[600px] w-full overflow-y-auto p-4 space-y-4">
          <pre className="whitespace-pre-wrap text-base leading-relaxed">{feedback}</pre>
        </div>
      </div>
    </div>
  );
}

